var _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutputPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 101,
    viewBox: "0 0 125 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.7 81C124.7 91.88 115.88 100.7 105 100.7L20.0003 100.7C9.12034 100.7 0.300361 91.88 0.30036 81L0.300356 15.0429L124.7 15.0429L124.7 81Z",
    fill: "white",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.302794 15.7818C0.462709 7.20421 7.46598 0.3 16.0818 0.3L108.918 0.3C117.534 0.3 124.537 7.20421 124.697 15.7818L0.302794 15.7818Z",
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9649,
    cy: 8.04088,
    r: 1.89298,
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.2748,
    cy: 8.04088,
    r: 1.89298,
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5847,
    cy: 8.04088,
    r: 1.89298,
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3103 78.7828H53.69C48.2093 78.7828 43.7663 74.3398 43.7663 68.8591V64.9515C43.7663 63.4104 45.0156 62.1611 46.5566 62.1611C48.0977 62.1611 49.347 63.4104 49.347 64.9515V68.8591C49.347 71.2576 51.2913 73.202 53.6898 73.202H71.3102C73.7087 73.202 75.653 71.2576 75.653 68.8591V64.9515C75.653 63.4104 76.9023 62.1611 78.4434 62.1611C79.9844 62.1611 81.2337 63.4104 81.2337 64.9515V68.8591C81.2341 74.3398 76.791 78.7828 71.3103 78.7828Z",
    fill: "#EBF2F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5565 61.4744C44.639 61.4744 43.0795 63.0339 43.0795 64.9513V68.8588C43.0795 74.7091 47.8398 79.4694 53.6902 79.4694H71.3105C77.1609 79.4694 81.9205 74.7091 81.9205 68.8588V64.9513C81.9205 63.0339 80.361 61.4744 78.4435 61.4744C76.5261 61.4744 74.9666 63.0339 74.9666 64.9513V68.8588C74.9666 70.8748 73.3267 72.5154 71.3105 72.5154H53.6902C51.6742 72.5154 50.0336 70.8748 50.0336 68.8588V64.9513C50.0336 63.0339 48.4741 61.4744 46.5565 61.4744ZM53.6902 73.8886H71.3105C74.0835 73.8886 76.3396 71.6324 76.3396 68.8588V64.9513C76.3396 63.7915 77.2836 62.8474 78.4435 62.8474C79.6033 62.8474 80.5475 63.7913 80.5475 64.9513V68.8588C80.5475 73.9522 76.4041 78.0962 71.3105 78.0962H53.6902C48.5968 78.0962 44.4527 73.9522 44.4527 68.8588V64.9513C44.4527 63.7915 45.3967 62.8474 46.5566 62.8474C47.7166 62.8474 48.6606 63.7913 48.6606 64.9513V68.8588C48.6604 71.6326 50.9165 73.8886 53.6902 73.8886Z",
    fill: "#D2DBE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0214 44.4199L61.079 36.8404C61.8479 36.0096 63.1523 36.0096 63.9214 36.8404L66.0566 39.1335L70.9792 44.4199C72.1327 45.6625 71.2538 47.6879 69.5511 47.6879L66.9079 47.6879L66.9079 59.9702C66.9079 61.8375 65.7476 63.4373 64.1068 64.0758C63.6125 64.2681 63.0632 64.3779 62.5004 64.3779C61.2852 64.3779 60.1799 63.8836 59.3834 63.0872C58.587 62.2907 58.0927 61.1922 58.0927 59.9702L58.0927 47.6879L55.4494 47.6879C53.7466 47.6879 52.8679 45.6625 54.0214 44.4199Z",
    fill: "#EBF2F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M61.1064 53.0085C61.1064 47.7358 62.96 42.9093 66.0564 39.1334L70.979 44.4198C72.1325 45.6624 71.2536 47.6878 69.551 47.6878L66.9077 47.6878L66.9077 59.9701C66.9077 61.8375 65.7474 63.4372 64.1067 64.0757C62.1982 60.8283 61.1064 57.0455 61.1064 53.0085Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5004 65.0642C65.3083 65.0642 67.5931 62.7792 67.5931 59.9715L67.5931 48.3747L69.5529 48.3747C71.8533 48.3747 73.0444 45.6337 71.4798 43.9517L64.4273 36.3702C63.3803 35.2456 61.6099 35.2554 60.5735 36.3702L53.5209 43.9511C51.9539 45.6358 53.1509 48.3748 55.4479 48.3748L57.4076 48.3748L57.4076 59.9715C57.4076 62.7794 59.6925 65.0642 62.5004 65.0642ZM55.4479 47.0015C54.3462 47.0015 53.775 45.6938 54.5266 44.8861L61.5791 37.3047C62.0743 36.7722 62.9205 36.7659 63.4215 37.3047L70.474 44.8861C71.2244 45.6938 70.6554 47.0015 69.5527 47.0015L66.9065 47.0015C66.527 47.0015 66.2199 47.3085 66.2199 47.6881L66.2199 59.9715C66.2199 62.0225 64.5512 63.6912 62.5002 63.6912C60.4492 63.6912 58.7805 62.0225 58.7805 59.9715L58.7805 47.6881C58.7805 47.3085 58.4734 47.0015 58.0939 47.0015L55.4479 47.0015Z",
    fill: "#D2DBE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutputPlaceholder);
export default __webpack_public_path__ + "static/media/output-placeholder.57f75e706a9d217ebb6757edd935e7cf.svg";
export { ForwardRef as ReactComponent };